import React, {Component} from 'react';
import "./ShafafiyaRegistration.css";
import {DateNavigation} from "../../../../components/datenavigation/DateNavigation";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import PageTitle from "../../../../layout/PageTitle";
import DateUtil from "../../../../utils/DateUtil";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import {Button, Image} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Badge, NavLink, SelectInput} from "../../../../components";
import EnumGender from "../../../../enums/EnumGender";
import PatientUtil from "../../../../utils/PatientUtil";
import StringUtil from "../../../../utils/StringUtil";
import FileUtil from "../../../../utils/FileUtil";
import confirmDialog from "../../../../components/dialog/ConfirmDialog";
import NotificationService from "../../../../services/notification-service/NotificationService";

export default class ShafafiyaRegistration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            selectedRows: [],
            selectedDate: null,
            genderFilterVal: null,
            insuranceFilterVal: null,
            shafafiyaFilterVal: null
        };
    }

    componentDidMount() {
        if (this.props.selected) {
            this.retrieveAppointments();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.selected && this.props.selected) {
            this.retrieveAppointments(this.state.selectedDate == null ? undefined : this.state.selectedDate);
        }
    }

    handleDateStateChange = (date) => {
        this.retrieveAppointments(date);
        this.setState({selectedDate: date, selectedRows: []});
    }

    retrieveAppointments(date = DateUtil.today()) {
        const startOfDay = new Date(date);
        startOfDay.setHours(0, 0, 0, 0);

        const endOfDay = new Date(date); // TODO no need for timezone adjustment for now
        endOfDay.setHours(23, 59, 59, 999);

        const params = {
            startTime: startOfDay.toISOString(),
            endTime: endOfDay.toISOString(),
            staffIds: []
        };

        RemotingService.getRemoteCall('api/appointment/list', params, (result) => {
            const appointments = result.items;
            const mappedAppointments = appointments.map((appointment) => {
                const mapped = {...appointment};
                mapped.age = appointment.patient.birthday ? DateUtil.getAge(appointment.patient.birthday) : '-';
                const startTime = DateUtil.formatDate(appointment.start, "hh:mm A");
                const endTime = DateUtil.formatDate(appointment.end, "hh:mm A");
                mapped.timeSlot = startTime + " - " + endTime;
                mapped.patientName = PatientUtil.getPatientsName(appointment.patient);
                return mapped;
            });
            this.setState({items: mappedAppointments});
        });
    }

    handleSelectionChange = (e) => {
        if (e.value.some(row => row.patient.shafafiyaSent)) {
            NotificationService.showNotification({
                severity: 'warn',
                summary: 'Already Submitted',
                detail: 'This patient was already submitted to Shafafiya.'
            });
        }
        const filteredSelection = e.value.filter(row => !row.patient.shafafiyaSent);
        this.setState({selectedRows: filteredSelection});
    }

    handleDownloadXmlClick = () => {
        if (this.state.selectedRows.length > 0) {
            const uniquePatientIds = [...new Set(this.state.selectedRows.map(a => a.patient.id))];
            RemotingService.getRemoteCall("api/shafafiya/person/xml?ids=" + uniquePatientIds.join(','), null, (xmlText) => {
                FileUtil.saveAs('Person.Register', xmlText, FileUtil.FileType.XML);
            });
        }
    }

    handleSendXmlClick = () => {
        if (this.state.selectedRows.length > 0) {
            const uniquePatientIds = [...new Set(this.state.selectedRows.map(row => row.patient.id))];

            confirmDialog(
                "Submit to Shafafiya",
                `Are you sure you want to submit ${uniquePatientIds.length} patient(s) to Shafafiya?`,
                () => {
                    RemotingService.postRemoteCall("api/shafafiya/person/xml?ids=" + uniquePatientIds.join(','), null, (result) => {
                        this.setState({selectedRows: []});
                        this.retrieveAppointments(this.state.selectedDate);
                    });
                }
            );
        }
    }

    patientNameTemplate = (rowData) => {
        let photoSrc = process.env.PUBLIC_URL + '/assets/patient_profile.png';
        if (rowData.patient.thumbnail) {
            photoSrc = 'data:image/jpeg;base64,' + rowData.patient.thumbnail;
        }
        return (
            <div className="d-flex flex-row align-items-center">
                <Image src={photoSrc} rounded width={"40px"} style={{paddingRight: 5}}/>
                <NavLink to={'/patientdetail/' + rowData.patient.id}>{rowData.patientName}</NavLink>
            </div>
        );
    }

    staffNameTemplate = (rowData) => {
        return (<NavLink to={'/staffprofile/' + rowData.staff.id}>{rowData.staff.name}</NavLink>);
    }

    genderTemplate = (rowData) => {
        return <>{EnumGender[rowData.patient.gender]}</>;
    }

    mrnTemplate = (rowData) => {
        return StringUtil.mrn(rowData.patient.mrn);
    }

    insuranceTemplate = (rowData) => {
        return rowData.insuranceExists ? 'Yes' : 'No';
    }

    shafafiyaStatusTemplate = (rowData) => {
            return rowData.patient.shafafiyaSent ?
                <Badge className="TableColBadge" style={{backgroundColor: "green", color: "white", paddingTop: 6, paddingBottom: 11}}>Sent</Badge> :
                <Badge className="TableColBadge" style={{backgroundColor: "red", color: "white", paddingTop: 6, paddingBottom: 11}}>Not Sent</Badge>
    }

    onGenderFilterChange = (val) => {
        this.dataTableRef.filter(val, 'patient.gender', 'equals');
        this.setState({genderFilterVal: val});
    }

    onInsuranceFilterChange = (val) => {
        this.dataTableRef.filter(val, 'insuranceExists', 'equals');
        this.setState({insuranceFilterVal: val});
    }

    onShafafiyaFilterChange = (val) => {
        this.dataTableRef.filter(val, 'patient.shafafiyaSent', 'equals');
        this.setState({shafafiyaFilterVal: val});
    }

    render() {
        const {selectedRows} = this.state;
        const patientsSelected = selectedRows.length > 0;

        const genderFilter = (
            <SelectInput className="w-100" value={this.state.genderFilterVal}
                         options={EnumGender.toArray()}
                         displayProperty="name" valueProperty="key" searchEnabled={false}
                         onChange={(val) => this.onGenderFilterChange(val)}/>
        );

        const insuranceFilter = (
            <SelectInput className="w-100" value={this.state.insuranceFilterVal}
                         options={[{key: false, name: "No"}, {key: true, name: "Yes"}]}
                         displayProperty="name" valueProperty="key" searchEnabled={false}
                         onChange={(val) => this.onInsuranceFilterChange(val)}/>
        );

        const shafafiyaFilter = (
            <SelectInput className="w-100" value={this.state.shafafiyaFilterVal}
                         options={[{key: false, name: "Not Sent"}, {key: true, name: "Sent"}]}
                         displayProperty="name" valueProperty="key" searchEnabled={false}
                         onChange={(val) => this.onShafafiyaFilterChange(val)}/>
        );

        return (
            <>
                <div style={{padding: '10px'}} className="data-table-header-wrapper">
                    <div className="float-left">
                        <PageTitle title="Shafafiya Patient Register" className="bg-white"/>
                    </div>
                    <div className="float-right">
                        <DateNavigation onDateChange={this.handleDateStateChange} displayDate={true}/>
                    </div>
                </div>

                <div style={{padding: '10px'}}>
                    <div className="d-flex mb-2">
                        <Button
                            style={{height: "fit-content"}}
                            variant="primary"
                            onClick={this.handleDownloadXmlClick}
                            disabled={!patientsSelected}
                        >
                            <FontAwesomeIcon icon="file-download"/> Download XML
                        </Button>
                        <Button
                            style={{height: "fit-content", marginLeft: "10px"}}
                            variant="success"
                            onClick={this.handleSendXmlClick}
                            disabled={!patientsSelected}
                        >
                            <FontAwesomeIcon icon="upload"/>Send XML
                        </Button>
                    </div>

                    <DataTable
                        className="ShafafiyaTable"
                        ref={(el) => this.dataTableRef = el}
                        value={this.state.items}
                        emptyMessage={"No appointments found for selected date"}
                        rows={20}
                        scrollable
                        paginator={true}
                        paginatorPosition="bottom"
                        selection={this.state.selectedRows}
                        onSelectionChange={this.handleSelectionChange}
                        dataKey="id"
                    >
                        <Column selectionMode="multiple" style={{width: '3em'}}/>
                        <Column header="Time Slot" field="timeSlot" sortable style={{width: '120px'}}/>
                        <Column header="MRN" field="patient.mrn.mrnNo" body={this.mrnTemplate}
                                filter={true} filterMatchMode="contains" sortable style={{width: '80px'}}/>
                        <Column header="Patient Name" field="patientName" body={this.patientNameTemplate}
                                filter={true} filterMatchMode="contains" sortable style={{width: '250px'}}/>
                        <Column header="Age" field="age" sortable style={{width: '50px'}}/>
                        <Column header="Gender" field="patient.gender" body={this.genderTemplate}
                                filter={true} filterElement={genderFilter} sortable style={{width: '180px'}}/>
                        <Column header="Mobile" field="patient.mobilePhone"
                                filter={true} filterMatchMode="contains" style={{width: '120px'}}/>
                        <Column header="Insurance" field="insuranceExists" body={this.insuranceTemplate}
                                filter={true} filterElement={insuranceFilter} sortable style={{width: '80px'}}/>
                        <Column header="Provider" field="staff.name" body={this.staffNameTemplate}
                                filter={true} filterMatchMode="contains" sortable style={{width: '150px'}}/>
                        <Column header="Sent to Shafafiya" field="patient.shafafiyaSent" body={this.shafafiyaStatusTemplate}
                                filter={true} filterElement={shafafiyaFilter} style={{width: '80px'}}/>
                    </DataTable>
                </div>
            </>
        );
    }
}
